import { Component, TemplateRef, ViewChild } from '@angular/core';

import { PlacePanel } from '@unpispas/upp-base';
import { UppPinpadHomeComponent } from '@unpispas/feature/pinpad';
import { UppPinpadWorkComponent } from '@unpispas/feature/pinpad';

/**
 * App-owned PLACE composition: pinpad chrome + ticket/mesa/cart hosts.
 * Keeps `feature/pinpad` free of `upp-ticket-*` / `upp-cart-select` / `upp-table-edit` mounts.
 */
@Component({
    selector: 'app-ptf-place-shell',
    templateUrl: './ptf-place-shell.html',
    styleUrl: './ptf-place-shell.scss',
})
export class PtfPlaceShellComponent {
    @ViewChild('ticketDetailTpl', { static: true })
    ticketDetailTpl!: TemplateRef<{ $implicit: UppPinpadWorkComponent }>;

    @ViewChild('tableDetailTpl', { static: true })
    tableDetailTpl!: TemplateRef<{ $implicit: UppPinpadWorkComponent }>;

    @ViewChild('cartTpl', { static: true })
    cartTpl!: TemplateRef<unknown>;

    @ViewChild('ticketsTpl', { static: true })
    ticketsTpl!: TemplateRef<{ $implicit: UppPinpadWorkComponent }>;

    async OnHomePanel(home: UppPinpadHomeComponent, panel: PlacePanel): Promise<boolean> {
        return home.OnWorkPanel(panel);
    }
}
